import isMobile from '../common/is-mobile.js';


$(window).on("resize", function(){
  var topImage = $('.top-main-slider__image');
  if(!isMobile(1020)){
    $(topImage).attr("data-zs-src",'["assets/img/top/img_main01.jpg", "assets/img/top/img_main02.jpg", "assets/img/top/img_main03.jpg", "assets/img/top/img_main04.jpg"]');
  } else {
    $(topImage).attr("data-zs-src",'["assets/img/top/img_main01_sp.jpg", "assets/img/top/img_main02_sp.jpg", "assets/img/top/img_main03_sp.jpg", "assets/img/top/img_main04_sp.jpg"]');
  }
}).trigger("resize");
